import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @repo/internal/react/no-unsafe-overrides */
import React, { forwardRef } from 'react';
import { CustomItem as Custom } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

// Dirty hack to get generics working with forward ref [1/2]

/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */
const CustomItem = /*#__PURE__*/forwardRef(
// Type needed on props to extract types with extract react types.
({
  cssFn,
  ...rest
}, ref) => {
  const {
    shouldRender
  } = useShouldNestedElementRender();
  if (!shouldRender) {
    return null;
  }
  const cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);
  // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
  return /*#__PURE__*/React.createElement(Custom, _extends({
    ref: ref,
    cssFn: cssOverride
  }, rest));
}
// Dirty hack to get generics working with forward ref [2/2]
);
export default CustomItem;